import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexColumn)`
    gap: 16px;
    padding: 24px 24px 0;
`;

export const OptionsTitle = styled.div`
    margin-top: 8px;
    ${setFontVariant("subtitle1", colorsPalettes.carbon["500"])};
`;
